import clsx from "clsx";
import React from "react";

export default function Button({ children, className, color, theme }) {
   let background = "";

   switch (color) {
      case "secondary":
         background = "bg-secondary hover:bg-secondary-hover";
         break;
      case "danger":
         background = "bg-red-custom hover:bg-red-custom-hover";
         break;
      default:
         background = "bg-primary hover:bg-primary-hover";
         break;
   }

   switch (theme) {
      case "small":
         return (
            <button
               className={clsx(
                  className,
                  background,
                  "px-3 py-1.5 uppercase font-medium font-secondary text-xs text-white animated shadow-md"
               )}
            >
               {children}
            </button>
         );
      case "big":
         return (
            <button
               className={clsx(
                  className,
                  background,
                  "uppercase font-medium font-secondary text-white px-8 py-4 animated shadow-md"
               )}
            >
               {children}
            </button>
         );
      default:
         return (
            <button
               className={clsx(
                  className,
                  background,
                  "uppercase font-medium font-secondary text-md md:text-lg text-white px-5 py-2 tracking-wider  animated shadow-md"
               )}
            >
               {children}
            </button>
         );
   }
}
